import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const PhoneContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 2.4rem;
  ${mq.medium} {
    gap: 3rem;
  }
  width: 100%;
  margin: auto;
  max-width: 1545px;
  @media (max-width: 1605px) {
    max-width: calc(100% - var(--spacing-sm));
  }
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    max-width: calc(60rem + 2 * var(--spacing-sm));
  }
  @media (max-width: 48em) {
      padding: 0 var(--spacing-sm);
    }
  }
`

export const Phone = styled.div`
  border-radius: var(--border-radius);
  background: #ffedf4;
  padding: 12px var(--spacing-sm);
  margin: 0 auto;
  font-style: italic;
  ${theme.shadow()}

  ${mq.small} {
    padding: 8px var(--spacing-sm);
  }
  ${mq.medium} {
    padding: 10px var(--spacing-sm);
  }
  @media (max-width: 1024px) {
    display: flex;
    width: 100%;
    align-items: center;
  }
  img {
    display: block;
    margin: 0.5em auto;
    width: 88px;
    @media (max-width: 1605px) {
      width: 70px;
    }
    @media (max-width: 1024px) {
      width: 82px;
      margin: 0.5em 8rem 0.5rem 5rem;
    }

    @media (max-width: 48em) {
      margin: 0.5em 4rem 0.5rem 3rem;
      width: 46px;
    }
  }
`
